export default __webpack_public_path__ + "static/media/screen_google_drive_05.917dc407.png";